import React from "react";

const About = () => {
  return (
    <div>
      <h1>About Github Finder</h1>
      <p>App to search Github Users</p>
      <p>Version: 1.0</p>
    </div>
  );
};

export default About;
